<template>
    <div v-if="retreiveTreatmentForm ">
        <request v-if="this.treatment_form.main_request" :is_main="true"
                  :request="this.treatment_form.main_request.request">
        </request>
        <div class="main_request_container" >
          <div v-if="this.treatment_form.main_request.model_current_version != null && Object.keys(this.treatment_form.main_request.model_current_version).length" class="actual_container">
            <h3 class="title_models">Version actuelle</h3>
            <current-model v-if="this.treatment_form.main_request.model_current_version"
                        :model="this.treatment_form.main_request.model_current_version"
                        :type="this.treatment_form.main_request.request.type.name">
            </current-model>
          </div>
          <div v-if="Object.keys(this.treatment_form.main_request.model_new_version).length || this.treatment_form.main_request.model_new_version != null" class="new_container">
            <h3 class="title_models" v-if="!this.treatment_form.main_request.request.type.name.includes('contract')">Nouvelle version</h3>
            <h3 class="title_models" v-else>Détail de la commande</h3>
            <new-model v-if="this.treatment_form.main_request.model_new_version"
                        :model="this.treatment_form.main_request.model_new_version"
                        :type="this.treatment_form.main_request.request.type.name">
            </new-model>
          </div>
        </div>
        <div v-if="this.treatment_form.child_requests.length" class="child_request_container">
          <div v-for="(child_req, idx) in treatment_form.child_requests">
            <div >
              <request :request="child_req.request" :is_main="false">
              </request>
              <div class="child_subrequest_container">
                <div v-if="Object.keys(child_req.model_current_version).length" class="actual_container">
                  <h3 class="title_models">Version actuelle</h3>
                  <current-model v-if="child_req.model_current_version"
                              :model="child_req.model_current_version"
                              :type="child_req.request.type.name">
                  </current-model>
                </div>
                <div v-if="Object.keys(child_req.model_new_version).length" class="new_container">
                  <h3 class="title_models">Nouvelle version</h3>
                  <new-model v-if="child_req.model_new_version"
                              :model="child_req.model_new_version"
                              :type="child_req.request.type.name">
                  </new-model>
                </div>
              </div>
            </div>
          </div>
        </div>

        <related-models v-if="this.treatment_form.main_request && this.treatment_form.main_request.related_models && Object.keys(this.treatment_form.main_request.related_models).length"
                        :models="this.treatment_form.main_request.related_models">
        </related-models>

        <!-- <div v-if="treatment_form.main_request && treatment_form.main_request.form && treatment_form.main_request.form.schema">

          <h4> Données requises: </h4>
          <resource-form v-if="treatment_form.main_request.form && treatment_form.main_request.form.schema"
                :model="treatment_form.main_request.form.model"
                :triggers="treatment_form.main_request.form.triggers"
                :schema="treatment_form.main_request.form.schema"
                @submit="storeOptionalParams"
                :realtimeUpdate="true"
                :submit-button="false"
                >
          </resource-form>
        </div> -->

    </div>
</template>
<script>
import { resolveMutation, resolveState } from 'store/modules/tabs/tabManagerFactory'
import {mapActions, mapGetters, mapState} from 'vuex'
import ResourceForm from "components/Forms/ResourceForm"


import Request from './Request'
import RelatedModels from './RelatedModels'
import CurrentModel from './CurrentModel'
import NewModel from './NewModel'

export default {
    name:"Step1",

    components:{
      Request,
      RelatedModels,
      CurrentModel,
      NewModel,
      ResourceForm,
    },

    data() {
      return {
        moduleState: resolveState('treatmentDemandTabs', this.$store.state),
        treatment_form:{},
        demand_id:this.$route.params.id,
        anim_handler:null,
      }
    },

    computed:{
      ...mapState('demands', ['forms']),

      retreiveTreatmentForm() {
        this.treatment_form = _.find(this.forms, (tf) => tf.main_request.request.id == this.demand_id)
        if (this.treatment_form)
          return true
        return false
      },

    },

    methods: {
      ...mapActions('demands', ['validationRequestTreatmentForm','store_optional_params']),

      checkIfSchemaIsValide(schema) {
        if (schema && Object.keys(schema).length > 0)
          return true
        return false
      },

      isEmpty(obj) {
        for(var key in obj) {
          if(obj.hasOwnProperty(key))
              return false
          }
        return true
      },

      storeOptionalParams (event) {
        if (event)
          this.store_optional_params(event)
      },

      activateTabRequestedInRoute() {
        const requestedTab = this.$route.params.tab

        if (undefined !== requestedTab) {
          let filteredTabs = []
          if (this.moduleState.available_tabs_indexes == null) {
            filteredTabs = this.moduleState.tabsArray
          } else {
            filteredTabs = _.filter(this.moduleState.tabsArray, tab =>
              _.find(this.moduleState.available_tabs_indexes, idx => _.indexOf(this.moduleState.tabsArray, tab) === idx) != undefined
            )
          }

          const tabIndex = _.findIndex(filteredTabs, { name: requestedTab })
          
          if (tabIndex !== -1) {
            this.$store.commit('tabs/treatmentDemandTabs/TAB_ACTIVATION', tabIndex)
          } else {
            this.$router.push({
              name: 'customer',
              params: { id: this.customerId }
            })
          }
        }
      }
    },

    mounted() {
        this.validationRequestTreatmentForm(this.demand_id)
          // Tab activation performed in this step and not in the main component
          // because of poor implementation logic (step component creation required)
          .then(() => this.activateTabRequestedInRoute())
        function animate() {
            $('.left').fadeTo(500, 1).delay(500).fadeTo(500, 0)
            $('.middle').delay(250).fadeTo(500, 1).delay(500).fadeTo(500, 0)
            $('.right').delay(500).fadeTo(500, 1).delay(500).fadeTo(500, 0)
        }
        this.anim_handler = setInterval(animate, 4000);
    },

    beforeDestroy() {
      $('.left').stop()
      $('.middle').stop()
      $('.right').stop()
      clearInterval(this.anim_handler)
    },
}

</script>
<style scoped>
.main_request_container, .child_subrequest_container {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}

.main_request_container > div, .child_subrequest_container > div { margin-right: 20px; }
.main_request_container > div:last-child, .child_subrequest_container > div:last-child { margin-right: 0; }

.actual_container {
  width: 100%;
  background-color: #fff;
}

.new_container {
  width: 100%;
  background-color: white;
}

h3.title_models {
  text-align: center;
}

.new_container .title_models {
}


.animation_container {
  width: -webkit-fill-available;
  display: flex;
  justify-content: center;
  align-items: center;
}

.arrows_container {
  top: 40%;
  left: 10%;
}
#arrows{
  text-align: -webkit-center;
}

#arrows .arrow{
    background:url('~assets/img/demands/right-arrow-pink.png') no-repeat;
    height:49px;
    width:40px;
    float:left;
    opacity: 0;
}

.centered {
  align-self: center;
  display: inline-flex;
}

@media screen and (max-width: 800px) {
  #arrows {
    width: 49px;
  }

  #arrows .arrow{
      background:url('~assets/img/demands/right-arrow-pink.png') no-repeat;
      -webkit-transform: rotate(90deg);
      height:49px;
      width:40px;
      float:top;
      opacity: 0;
  }

  .centered {
    display: block;
  }

  .actual_container {

  }

  .new_container {

  }

  .animation_container {
    height: 150px;

  }
}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Step1.vue